export default __webpack_public_path__ + "static/media/BellIcon.01eb9a0f.svg";